import { useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Input } from '@/components/ui/input'

interface RejectModalProps {
  open: boolean
  onOpenChange: (_open: boolean) => void
  onConfirm: (_reasons: string[], _otherReason?: string) => void
  isRejecting?: boolean
}

const rejectionReasons = [
  'Violação de Direitos',
  'Sem Relevância',
  'Spam',
  'Conteúdo Ofensivo',
  'Conteúdo Redundante',
  'Anúncio',
  'Conteúdo +18'
]

export function RejectModal({ open, onOpenChange, onConfirm, isRejecting = false }: RejectModalProps) {
  const [selectedReasons, setSelectedReasons] = useState<string[]>([])
  const [otherReason, setOtherReason] = useState('')

  const handleReasonChange = (reason: string, checked: boolean) => {
    if (checked) {
      setSelectedReasons([...selectedReasons, reason])
    } else {
      setSelectedReasons(selectedReasons.filter(r => r !== reason))
    }
  }

  const handleConfirm = () => {
    if (selectedReasons.length === 0 && !otherReason.trim()) {
      return
    }
    onConfirm(selectedReasons, otherReason.trim() || undefined)
    setSelectedReasons([])
    setOtherReason('')
  }

  const handleClose = () => {
    if (!isRejecting) {
      setSelectedReasons([])
      setOtherReason('')
      onOpenChange(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-center">
            Por quê deseja rejeitar o conteúdo?
          </DialogTitle>
          <p className="text-sm text-gray-600 mt-2 text-center">
            Ao rejeitar o conteúdo, ele é automaticamente tirado da Timeline do Culture Monitor e poderá ser acessado na aba "Conteúdos Rejeitados"
          </p>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div>
            <h3 className="font-semibold mb-3">Motivo da Rejeição</h3>
            <div className="grid grid-cols-2 gap-3">
              {rejectionReasons.map((reason) => (
                <div key={reason} className="flex items-center space-x-2">
                  <Checkbox
                    id={reason}
                    checked={selectedReasons.includes(reason)}
                    onCheckedChange={(checked) => handleReasonChange(reason, checked as boolean)}
                    disabled={isRejecting}
                  />
                  <label
                    htmlFor={reason}
                    className="text-sm cursor-pointer"
                  >
                    {reason}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium">Outro:</label>
            <Input
              placeholder="Escreva o motivo"
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
              disabled={isRejecting}
            />
          </div>
          <div className="flex justify-end gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={handleClose}
              disabled={isRejecting}
              className="bg-red-600 text-white hover:bg-red-700 hover:text-white border-red-600"
            >
              Cancelar
            </Button>
            <Button
              type="button"
              onClick={handleConfirm}
              disabled={isRejecting || (selectedReasons.length === 0 && !otherReason.trim())}
              className="bg-black text-white hover:bg-gray-800"
            >
              {isRejecting ? 'Rejeitando...' : 'Rejeitar Conteúdo'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
